import "core-js/modules/es.array.index-of.js";
// Duplicated from ab-common
function toUrl(url) {
  if (typeof url !== 'string') return null;
  if (url.indexOf('http') !== 0) return "http://".concat(url);
  return url;
}
export default toUrl;